import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { getSetting } from '@woocommerce/settings';
import { decodeEntities } from '@wordpress/html-entities';
import { __ } from '@wordpress/i18n';
import { useSelect, useDispatch } from '@wordpress/data';

interface InvoicedSettings {
	title: string;
	description: string;
	supports: string[];
}

const settings = getSetting<InvoicedSettings>( 'crsc_invoiced_data', {
	title: __( 'Invoicing', 'crsc-woocommerce-invoice' ),
	description: __( 'Only companies that have been pre-approved by Chesapeake Region Safety Council\'s finance department can be invoiced.Our Finance Department will be in contact with you about your invoice and payment options. Not student will be registered for the class until the invoice is paid in full. If you are working for a company and would like the option to be invoiced , please contact us by calling our office or emailing us at safety@chesapeakesc.org.', 'crsc-woocommerce-invoice' ),
	supports: [ 'products' ],
	placeOrderButtonLabel: __( 'Invoice Order', 'crsc-woocommerce-invoice' ),
	ariaLabel: __( 'Invoice my company for this order.', 'crsc-woocommerce-invoice' ),
} );

const label = decodeEntities( settings.title );

/**
 * Content component
 */
const Content = () => {
	const { extensionData } = useSelect( ( select ) => {
		const checkoutStore = select( 'wc/store/checkout' );
		return {
			extensionData: checkoutStore ? checkoutStore.getExtensionData() : {},
		};
	}, [] );

	const { setExtensionData } = useDispatch( 'wc/store/checkout' );

	const additionalFields = extensionData?.['woocommerce/additional-fields'] || {};
	const customerId = additionalFields?.['crsc/invoice-company-id'] || '';

	const handleInputChange = ( e: any ) => {
		const newValue = e.target.value;
		setExtensionData( 'woocommerce/additional-fields', {
			...additionalFields,
			'crsc/invoice-company-id': newValue,
		} );
	};

	return (
		<div className="crsc-woocommerce-invoice-content">
			<p className="crsc-woocommerce-invoice-description-above">{decodeEntities( settings.description )}</p>
			<label htmlFor="crsc_woocommerce_invoice_customer">{__( 'Invoice Company ID', 'crsc-woocommerce-invoice') }</label>
			<p className="crsc-woocommerce-invoice-description-below">{__( 'Enter your company’s assigned Invoice Company ID. This ID is provided by Chesapeake Region Safety Council to companies that have been approved for invoice billing.', 'crsc-woocommerce-invoice' )}</p>
			<input
				className="crsc_woocommerce_invoice_number_field"
				inputMode="numeric"
				pattern="[0-9]*"
				id="crsc_woocommerce_invoice_customer"
				name="crsc_woocommerce_invoice_customer"
				placeholder="Invoice Company ID"
				value={ customerId }
				onChange={ handleInputChange }
			/>
		</div>
	);
};

/**
 * Register the payment method
 */
registerPaymentMethod( {
	name: 'crsc_invoiced',
	label: label,
	content: <Content />,
	edit: <Content />,
	canMakePayment: () => true,
	ariaLabel: label,
	supports: {
		features: settings.supports || [],
	},
} );
